import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface StatusBadgeProps {
  status: 'success' | 'warning' | 'error' | 'info';
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  children,
  sx = {},
}) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'success':
        return {
          bgcolor: 'success.light',
          color: 'success.main',
        };
      case 'warning':
        return {
          bgcolor: 'warning.light',
          color: 'warning.main',
        };
      case 'error':
        return {
          bgcolor: 'error.light',
          color: 'error.main',
        };
      case 'info':
      default:
        return {
          bgcolor: 'info.light',
          color: 'info.main',
        };
    }
  };

  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: '0.75rem',
        fontWeight: 'semibold',
        textTransform: 'capitalize',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        ...getStatusStyles(),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
